export default "__VITE_ASSET__CIeobp11__"